import { useEffect, useState } from 'react';
import { accountsAPI } from '../lib/api';

let cached = null;

// Server-derived permissions (same policy that enforces mutations). Controls hide when not allowed.
export function usePermissions() {
  const [perms, setPerms] = useState(cached || { financial: false, operational: false, loaded: false });
  useEffect(() => {
    if (cached) return;
    accountsAPI.getMyPermissions()
      .then((r) => { cached = { ...r.data, loaded: true }; setPerms(cached); })
      .catch(() => setPerms({ financial: false, operational: false, loaded: true }));
  }, []);
  return perms;
}
